import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';

import { getFilterSectionFields } from '../../../config/filterFields';
import FilterInputGenerator from './FilterInputGenerator';

const useStyles = makeStyles(theme => ({
  modalContainer: {
    backgroundColor: 'rgba(4, 17, 38, 0.7)',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
  },
  modalHeadingClassName: {
    alignSelf: 'flex-start',
    color: 'white',
    marginBottom: '40px',
    fontSize: '25px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    height: '100%',
  },
  formMainContainer: {
    width: '100%',
    minHeight: 'unset',
    maxHeight: '74vh',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',

    '@media (min-width: 3440px)': {
      maxHeight: '30vh',
    },

    '@media (min-width: 1920px)': {
      maxHeight: '74vh',
    },

    '@media (max-width: 1920px)': {
      maxHeight: '78vh',
    },

    '@media (max-width: 1720px)': {
      maxHeight: '78vh',
    },

    '@media (max-width: 1400px)': {
      maxHeight: '100vh',
    },

    '@media (max-width: 1240px)': {
      maxHeight: '180vh',
    },

    '@media (max-width: 800px)': {
      maxHeight: '200vh',
    },

    '@media (max-width: 768px)': {
      maxHeight: 'unset',
      minHeight: '100vh',
      flexDirection: 'unset',
      justifyContent: 'center',
    },
  },
  heaingImage: {
    width: '30px',
    marginLeft: '20px',
  },
  filtersDropdownContainer: {
    width: '100%',
    background: '#fff',
    padding: '25px',
    borderBottom: '1px solid rgba(130,194,195, 0.5)',
  },
  submitBtn: {
    '@media (max-width: 600px)': {
      padding: '8px 26px !important',
    },
    '@media (max-width: 400px)': {
      padding: '8px 30px !important',
    },
  },
  submitRow: {
    marginTop: '10px',
    marginBottom: '30px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    minHeight: '36px',
    '@media (max-width: 600px)': {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  marketSizeLabel: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.2,
    minHeight: '20px',
    whiteSpace: 'nowrap',
  },
}));

const themeButtonColor = {
  green: 'rgb(25, 152, 155)',
  yellow: '#AB8628',
  red: 'rgb(228, 85, 137)',
};

const FilterInputs = props => {
  const classes = useStyles();

  const [show, setShow] = useState(props.show);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  const filterSectionFields = getFilterSectionFields(props.pickedBatchCountry);

  return (
    <Box
      width="100%"
      display={show ? 'flex' : 'none'}
      justifyContent="center"
      alignItems="center"
      className={classes.filtersDropdownContainer}>
      <form onSubmit={props.onFiltersSubmit} onChange={props.onFiltersChange} className={classes.form}>
        <Box className={classes.submitRow}>
          <Typography className={classes.marketSizeLabel}>
            Market Size: {props.marketSizeFormattedPercentage || '0.0'}%
          </Typography>
          <Button
            type="submit"
            variant="contained"
            className={classes.submitBtn}
            style={{
              background: themeButtonColor[props.themeColor],
              color: '#fff',
            }}>
            Submit
          </Button>
        </Box>
        <Box className={classes.formMainContainer}>
          {filterSectionFields.map((section, index) => {
            return (
              <FilterInputGenerator
                key={index}
                themeColor={props.themeColor}
                section={section}
                setRangeWasTouched={props.setRangeWasTouched}
                selectValues={props.selectValues}
                onChangeSelectValues={props.onChangeSelectValues}
                resetAgeSliderValue={props.resetAgeSliderValue}
                setResetAgeSliderValue={props.setResetAgeSliderValue}
              />
            );
          })}
        </Box>
      </form>
    </Box>
  );
};

export default FilterInputs;
